<template>
  <div id="footer1">
    <div class="type_area footer1">
      <router-link  to="/" exact>Home</router-link>
      <span class="line"></span>
      <router-link  to="/product" exact :class='holdColor1?"active":""' >Product</router-link>
      <span class="line"></span>
      <router-link  to="/downlaod" exact>Download</router-link>
      <span class="line"></span>
      <router-link  to="/contact" exact>Contact</router-link>
      <span class="line"></span>
      <router-link  to="/about" exact>About</router-link>
<!--      <span class="line"></span>-->
<!--      <router-link  to="/news" exact :class='holdColor6?"active":""'>News</router-link>-->
<!--      <span class="line"></span>-->
<!--      <router-link  to="/problem" exact :class='holdColor2?"active":""'>Q&A</router-link>-->
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      holdColor1:false, // 默认不保持菜单的颜色
      holdColor2:false, 
      holdColor6:false, 
    }
  },

  mounted() {
    this.$Bus.$on('product',(data)=>{ // data为其它组件传来的值
      this.holdColor1=data
    })
    this.$Bus.$on('problem',(data)=>{ // data为其它组件传来的值
      this.holdColor2=data
    })
    this.$Bus.$on('news',(data)=>{ // data为其它组件传来的值
      this.holdColor6=data
    })
  },
};
</script>


<style scoped lang="less">
#footer1 {
  width: 100%;
  height: 4rem;
  background: #606060;
  // position: fixed;
  // bottom: 3rem;
  z-index: 9999;
  .footer1 {
    height: 100%;
    display:flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.8rem;
    .line {
        display:inline-block;
        width: 1px;
        height: 1rem;
        background: #fff;
    }
    a{
      color:#000;
    }
    .active{
      color:#257CE1 !important; 
      font-weight: bold;
    }
  }
}

// link to的激活样式
.router-link-active{
  color:#257CE1 !important;
  font-weight: bold;
}
</style>